import * as React from 'react';
import ContentModal from '../components/content-modal';
import MailIcon from '../../assets/images/mail-icon.png';
import Contact from '../../components/contact';
import styled from 'styled-components/native';
import config from './config';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function ContactScreen() {
  return (
    <Screen title="Contact" icon={MailIcon}>
      <Contact />
    </Screen>
  );
}
